var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"sheet",staticClass:"page-bottom-sheet"},[_c('v-bottom-sheet',{attrs:{"attach":this.$refs.sheet,"hide-overlay":""},model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[_c('v-sheet',{staticClass:"pa-4"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }